module.exports = __webpack_public_path__ + "assets/img/ISO9001BB.ad777eb9.png";